import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IUICfgAttributeDecimal } from '@canvas-logic/clp-api-types';
import { AttributeStateBase } from '@/elements/base/AttributeStateBase';

let id = 0;

export class DecimalAttributeState extends AttributeStateBase<IUICfgAttributeDecimal, number> {
  readonly elementKind = 'attribute';
  readonly elementType = 'decimal';
  public id = 'decimal-view-state-' + ++id;

  constructor(api: ICompositeProductApi, element: IUICfgAttributeDecimal) {
    super(api, element);
    this.initValueState();
  }
}
